import { useMemo, useCallback } from "react";
import Dropdown from "./Dropdown";

const DropDownCondition = ({
  value,
  onChange,
  items = [],
  disabled = false,
}) => {
  const mappedOptions = useMemo(() => {
    return (items || [])
      .filter((it) => it?.label && it?.concept_iri)
      .map((it) => ({
        label: it.label,
        value: it.concept_iri,
        code: it.code,
      }));
  }, [items]);

  const handleChange = useCallback(
    (eOrValue) => {
      const nextValue =
        typeof eOrValue === "string" ? eOrValue : eOrValue?.target?.value;
      onChange?.(nextValue);
    },
    [onChange],
  );

  return (
    <Dropdown
      variant="select"
      id="condition-select"
      value={value ?? ""}
      onChange={handleChange}
      options={mappedOptions}
      placeholderKey="dropdown.condition"
      disabled={disabled}
    />
  );
};

export default DropDownCondition;
